<template>
    <div>
        <navbar></navbar>
        <div class="container is-fullheight hero-body">
            <div class="columns is-centered">
                <div class="column is-6">
                    <login-logo></login-logo>
                    Registration Successful!
                </div>
                </div>
                <div class="columns is-centered">
                <div class="column is-6">
                    <div class="columns">
                        <div class="column is-12">
                            <div class="column is-12 has-text-centered">
                                <a class="is-dark" @click="openLogin()">Click here to login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Navbar from "./features/Navbar"
import LoginLogo from "./features/LoginLogo"
import LoginModal from "./modals/LoginModal"

export default {
    name: 'RegisterSuccess',
    data() {
        return {
            memberType: 0,
            hasError: false,
          activeTab: 0,
            memberCondition: false,
            marketingOperations: false,
            registrationError: false,
            registrationError_Password: false,
            registrationError_Email: false,
            nameSurname: '',
            email: '',
            password: '',
            passwordAgain: '',
        }
    },
    components: {
        Navbar,
        LoginLogo,
        LoginModal,
    },
    methods: {

        mounted() {

        },
        openLogin() {
            this.$modal.open({
                parent: this,
                component: LoginModal,
                hasModalCArd: true,
                props: {
                }
            })
        },
        memberConditionModal() {
            this.$modal.open({
                parent: this,
                component: MemberCondition,
                hasModalCArd: true,
                props: {
                }
            })
        },
        doRegister() {

        }
    }
}
</script>

<style scoped>
.why-should-i-register {
    margin-top: 20px !important;
}

.why-should-i-register-sub {
    margin-top: 10px !important;
}
.icon {
    border: 1px solid #e3e3e3 !important;
    border-radius: 100% !important;
}

.icon.is-large {
    height: 5rem !important;
    width: 5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterSuccess.vue